export const ENGLISH_TRANSLATIONS = {
  // MAIN COMPONENTS
  navbar: {
    options: {
      search: 'Search',
      payloads: 'Payloads',
      issues: 'Issues',
			images: 'Images',
			frauds: 'Frauds'
    },
    menu: {
      account: 'Account',
      return: 'Return to menu',
      configuration: 'Configuration',
      logOut: 'Log Out'
    },
  },
  landing: {
    description: 'This tool allows us to consult the information of a payload by visualizing and interacting with the pictures, being able to see the products that have been recognized by the image engine.'
  },
  configuration: {
    title: 'Configurations',
    options: {
      appearance: 'Appearance'
    },
    appearance: {
      themes: 'Themes',
      light: 'Light',
      dark: 'Dark'
    }
  },

  // SEARCH COMPONENTS
  search: {
    title: 'Search Payloads',
    errorAlertMsg: 'Missing fields!',
    errorLocationAlertMsg: 'No location was selected!',
    filters: {
      organization: 'Organization',
      orgLegend: 'Select an organization.',
      workspace: 'Workspace',
      workspaceLegend: 'Select a workspace.',
      module: 'Module',
      moduleLegend: 'Select a module.',
      searchFor: 'Search by:',
      searchForLegend: 'Select an option',
      searchForOptions: {
        name: 'Location name',
        code: 'Location code',
        payloadRef: 'Payload reference',
        issueRef: 'Issue reference'
      },
      cycle: 'Cycle',
      start: 'Start:',
      end: 'End:',
      cycleLegend: 'Select a cycle.',
    },
    nameOption: {
      alert: {
        msg: 'Location selected!',
        name: ' Name:',
        code: 'Code:'
      },
      location: 'Location name',
      locationLegend: 'Type the location name.'
    },
    codeOption: {
      errorAlert: {
        msg: 'Location not found!'
      },
      alert: {
        msg: 'Location found!',
        name: 'Name:',
        code: ' Code:'
      },
      location: 'Location code',
      locationLegend: 'Type the location code.',
    },
    payloadRefOption: {
      errorAlert: {
        msg: 'Payload not found!'
      },
      alert: {
        msg: 'Payload found!'
      },
      input: 'Payload Reference',
      inputLegend: 'Type the payload reference.',
    },
    issueRefOption: {
      errorAlert: {
        msg: 'Issue not found!'
      },
      alert: {
        msg: 'Issue found!'
      },
      input: 'Issue Reference',
      inputLegend: 'Type the issue reference.',
    },
    imageOption: {
      errorAlert: {
        msg: 'Imagen not found!'
      },
      alert: {
        msg: 'Imagen found!'
      },
			title: 'Search Images',
      input: 'Image Reference',
      inputLegend: 'Type image reference.',
			imgRecon: 'Recognition',
			imgType: 'Type',
			imgGroup: 'Group',
			goToImage: 'Go to image'
    },
    searchBtn: 'Search'
  },
  locationsTable: {
    headers: {
      name: 'Name',
      code: 'Code',
      status: 'Status'
    },
    errors: {
      noCode: 'No code',
      noLocations: 'No locations found'
    }
  },
  locationsRecords: {
    headers: {
      type: 'Type',
      date: 'Date',
      action: 'Action'
    },
    actions: {
      goToPayload: 'Go to payload',
      goToIssue: 'Go to issue'
    },
    errors: {
      noRecords: 'No records'
    },
    types: {
      payload: 'Payload',
      issue: 'Issue',
      other: 'Other'
    }
  },

  // ALL PAYLOADS COMPONENTS
  allPayloads: {
    title: 'Search Payloads',
    errorAlertMsg: 'Missing fields!',
    filters: {
      organization: 'Organization',
      orgLegend: 'Select an organization.',
      workspace: 'Workspace',
      workspaceLegend: 'Select a workspace.',
      module: 'Module',
      moduleLegend: 'Select a module.',
      submodule: 'Submodule',
      submoduleLegend: 'Select a submodule.',
      cycle: 'Cycle',
      cycleLegend: 'Select a cycle.',
      datePicker: 'Date',
      datePickerLegend: 'Select a date or a date range.',
      areas: 'Areas',
      areasLegend: 'Select areas.',
      areasOptions: {
        region: 'Region',
        zone: 'Zone',
        depot: 'Depot',
        group: 'Group',
        route: 'Route'
      }
    },
    searchBtn: 'Search'
  },
  payloadsTable: {
    headers: {
      code: 'Code',
      date: 'Date',
      status: 'Status',
      action: 'Action'
    },
    actions: {
      goToPayload: 'Go to payload'
    },
    errors: {
      noCode: 'No code',
      noPayloads: 'No payloads',
			noImages: 'No images'
    }
  },

  // PAYLOAD COMPONENTS
  payload: {
    title: 'General Data',
    loading: 'Loading information...',
		survey: {
			title: 'Survey',
			expand: 'Click to expand',
			collapse: 'Click to collapse'
		},
    locationInfo: {
      title: 'Location Information',
      code: 'Code',
      name: 'Name',
      description: 'Description',
      status: 'Status',
      lat: 'Latitude',
      lng: 'Longitude',
      creationDate: 'Date of creation',
      referenceImg: 'Reference image'
    },
    payloadInfo: {
      title: 'Payload Information',
			processType: {
				online: 'Payload sent in online mode.',
				offline: 'Payload sent in offline mode.'
			},
      workspace: 'Workspace',
      module: 'Module',
      submodule: 'Submodule',
      config: 'Configuration',
      user: 'User',
      cycle: 'Cycle',
      creationDate: 'Date of creation',
      region: 'Region',
      zone: 'Zone',
      depot: 'Depot',
      group: 'Group',
      route: 'Route',
      error: 'No information'
    },
    payloadStatus: {
      title: 'Payload Status',
      status: 'Status',
      statusDate: 'Date of last status',
      historyBtn: 'View status history'
    },
		payloadScore: {
			loading: 'Loading score...',
      title: 'Payload Score',
      score: 'Total Score',
			error: 'This payload has no score.'
    },
		payloadLocation: {
			title: 'Payload Location',
			distance: 'Distance',
			unitM: 'm',
			unitKm: 'km',
			between: 'between user and store',
		},
		rail: {
			title: 'On this page',
			store: 'Store',
			details: 'Details',
			status: 'Status',
			geo: 'Geo',
			score: 'Score',
			insights: 'Insights',
			content: 'Content'
		},
		payloadInsights: {
			title: 'Payload Insights',
			loading: 'Loading insights...',
			empty: 'This payload has no insights yet.',
			ledeRest: 'of {{evaluated}} evaluated rules pass in this census.',
			subAttentionOne: '{{count}} rule requires the store manager\'s attention.',
			subAttentionMany: '{{count}} rules require the store manager\'s attention.',
			subAllPass: 'All evaluated rules pass.',
			subNotEvaluatedOne: ' {{count}} could not be evaluated.',
			subNotEvaluatedMany: ' {{count}} could not be evaluated.',
			keystats: {
				pass: 'Pass',
				fail: 'Need attention',
				na: 'Not applicable',
				total: 'Total rules'
			},
			viewDetails: 'View Details',
			details: {
				back: 'Back to payload',
				stripRules: 'rules',
				stripPass: 'pass',
				stripFail: 'attention',
				stripNa: 'N/A',
				filters: {
					all: 'All',
					fail: 'Attention',
					pass: 'Pass',
					na: 'Not applicable',
					searchPlaceholder: 'Search rule…',
					noMatches: 'No insights match the current filters.'
				},
				groups: {
					pass: 'Pass',
					fail: 'Need attention',
					na: 'Not evaluable'
				},
				rowStatus: {
					pass: 'Pass',
					fail: 'Attention',
					na: 'N/A'
				}
			}
		},
		payloadMap: {
			point: 'Point',
			ditance: 'Distance',
		},
    payloadContent: {
      title: 'Payload Content',
      tableHeaders: {
        type: 'Type',
        info: 'Information',
        images: 'Images'
      },
      errors: {
        noContent: 'No content'
      }
    },
		reportError: {
			banner: {
				title: 'Found an error in this payload?',
				desc: 'Report issues with the score or with this payload\'s photos. Backoffice reviews your report and only one active review per payload is allowed.',
				btn: 'Report error',
				expiredTitle: 'Reporting window closed',
				expiredDesc: 'More than {{days}} days have passed since this payload was recorded. It can no longer be reported.',
				activeTitle: 'There is already a ticket for this payload',
				activeDesc: 'Backoffice is reviewing your report. You will be able to open another one when it is resolved.',
			},
		},
		share: {
			prompt: 'Need to share this payload?',
			copyUrl: 'Copy URL',
			copied: 'Copied!',
		}
  },
  statusModal: {
    title: 'Status History',
    tableHeaders: {
      prevStatus: 'Previous status',
      currentStatus: 'Current status',
      date: 'Date'
    },
    errors: {
      noHistory: 'No history'
    }
  },

  // ISSUE COMPONENTS
  issue: {
    allIssues: {
      title: 'Issues',
      issueTypeLegend: 'Select an issue type.',
    },
    issueInfo: {
      title: 'Issue Information',
			processType: {
				online: 'Issue sent in online mode.',
				offline: 'Issue sent in offline mode.'
			}
    },
    issueType: {
      title: 'Issue Type',
      issue_tag: 'Type(s) of custom tag(s): ',
      descriptions: {
        closed: 'The location is closed.',
        closed_down: 'The location is permanently closed.',
        access: 'Access to the location was not allowed.',
        process: 'The evaluation was not allowed.',
        products: 'The location does not have products related to the organization.',
        custom: 'Customized issue.'
      }
    },
    issuesTable: {
      headers: {
        code: 'Code',
        date: 'Date',
        type: 'Type',
        action: 'Action'
      },
      actions: {
        goToIssue: 'Go to issue'
      },
      errors: {
        noCode: 'No code',
        noIssues: 'No issues'
      }
    }
  },

  // DISPLAY COMPONENTS
  display: {
		returnPayload: 'Return to payload',
		returnSurvey: 'Return to survey',
		recon: 'Products Recognition',
		imgInfo: {
			title: 'Image Information',
			name: 'Name',
			type: 'Type',
			original: 'Original',
			globalTags: 'Global tags',
			resourceTags: 'Resource tags',
		},
		numTickets: 'Number of Tickets',
    imgType: 'Type:',
    imgName: 'Name:',
		resultHistory: 'Result History',
    loading: 'Loading result...',
    globalTags: 'Global tags: ',
    resourceTags: 'Resource tags: ',
    resultTypes: 'Result types:',
    alert: 'There is no recognition for this image.',
		alertTitle: 'No recognition available',
		alertArchive: 'This image has been accessed from the cloud storage archive.',
		archiveTitle: 'Image from cloud archive',
    resultInfo: {
      elements: 'Elements',
      predictions: 'Predictions',
      extras: 'Extras'
    },
    photosBtns: {
      previous: 'Previous Photo',
      next: 'Next Photo'
    },
    errors: {
      image: 'Error loading image'
    },
    actionBtns: {
      fullScreen: 'Open in new window',
      download: 'Download image',
      fitImg: 'Fit image',
      createTicket: 'Create Ticket',
      controls: 'Keyboard shortcuts',
    },
    productsGraph: 'Products Chart',
		reconModel: {
			model: 'Model',
			version: 'Version'
		},
		rail: {
			title: 'Sections',
			info: 'Info',
			recon: 'Recognition',
		},
		recognition: {
			title: 'Recognition',
			empty: 'Select a result type to see detected items.',
			unsupportedType: 'No list view for this result type.',
			showing: 'Showing',
		},
		result: {
			typesLabel: 'Result types',
		},
		summary: {
			title: 'Recognition Summary',
		},
		chart: {
			title: 'Products distribution',
		},
		taglist: {
			title: 'Detected items',
			products: 'Products',
			fronts: 'Fronts',
			hideAll: 'Hide all',
			showAll: 'Show all',
			opacity: 'Adjust opacity',
			doors: 'Doors',
		},
		reportError: {
			title: 'Report error',
			ticketPrefix: 'Report from Display',
			step: 'Step {{current}} / {{total}}',
			cancel: 'Cancel',
			back: 'Back',
			submit: 'Submit report',
			sending: 'Sending...',
			banner: {
				title: 'Did the engine make a mistake?',
				desc: 'Report corrections on detected products. Your score is recalculated instantly (provisional), and backoffice reviews your changes. Only one active review per photo is allowed.',
				btn: 'Report error',
				resolved: {
					ctaAgain: 'Report again',
					ctaNew: 'Open a new one',
					// Attribution for the QA note. Fixed on purpose: the history entry
					// never names the actor, so the note is credited to the team.
					note: {
						author: 'Backoffice',
					},
					approved: {
						title: 'Your report was approved',
						desc: 'The changes have been applied. If you spot another issue, you can open a new ticket.',
					},
					partial: {
						title: 'Your report was partially approved',
						desc: 'Backoffice applied part of your corrections. If you want to report what remains, you can open an additional ticket.',
					},
					rejected: {
						title: 'Your report was rejected',
						desc: 'Backoffice determined the correction did not apply. If you still see a problem, you can report again with more context.',
					},
					closed: {
						title: 'This ticket was closed',
						desc: 'It was closed without a specific action. If the problem persists, you can open a new ticket.',
					},
					outdated: {
						title: 'The report became outdated',
						desc: 'The data changed before backoffice could resolve it. If the problem still applies to the current version, open a new ticket.',
					},
					error: {
						title: 'There was an error applying your report',
						desc: 'Backoffice approved your changes but the system could not apply them. You can try with a new ticket or contact support if it persists.',
					},
				},
				// Ticket transition log, opened from the banner button. `author` is
				// fixed on purpose: the history entry never names the actor — see
				// pickStatusNote in ticketActions.js.
				history: {
					btn: 'View ticket history',
					title: 'Status history',
					eyebrow: 'Ticket {{code}}',
					eyebrowFallback: 'Ticket',
					empty: 'No history available.',
					author: 'Backoffice',
					close: 'Close history',
				},
				expiredTitle: 'Reporting window closed',
				expiredDesc: 'More than {{days}} days have passed since this payload was recorded. It can no longer be reported.',
				activeTitle: 'There is already a ticket for this payload',
				activeDesc: 'Backoffice is reviewing your report. You will be able to open another one when it is resolved.',
			},
			createErrors: {
				duplicate: 'There is already an open ticket for this item. Wait for backoffice to resolve it before opening another.',
				foreignOrg: 'This item belongs to another organization and cannot be reported.',
				reasonTarget: 'This reason does not apply to this kind of item. Pick another one.',
				noProposal: 'The selected reason does not accept a correction.',
			},
			step1: {
				heading: 'What type of error did you find?',
				subtext: 'Select the category that best describes the problem. This routes it to the right team.',
			},
			step2: {
				heading: 'Describe the problem',
				subtext: 'Backoffice will review your report. Once it is resolved, you will see the outcome right here.',
				detailsLabel: 'Error details',
				placeholder: 'Describe what value you expected, what you saw, or what was incorrect...',
				required: 'This field is required.',
				minHint: 'Minimum {{min}} characters.',
				minChars: 'Minimum {{min}} characters required.',
				notice: 'This type of error is not auto-corrected: it will be manually reviewed by the support team.',
			},
			categories: {
				score: {
					title: 'Incorrect score',
					desc: 'The final score does not reflect what you see in the photo, even though products are correctly recognized.',
				},
				recognition: {
					title: 'Recognition error',
					desc: 'Misidentified products, false positives, or missing boxes on the photo.',
				},
				autocorrect: {
					title: 'Recognition auto-correction',
					desc: 'You can manually correct products instantly. The score is recalculated immediately.',
					badge: 'Coming soon',
				},
			},
		},
		shortcuts: {
			scroll: 'Scroll wheel',
			leftClick: 'Left click',
		},
		hero: {
			photoOf: 'Photo {{current}} of {{total}}',
		},
  },
	controlsModal: {
		zoom: 'Zoom In/Out',
		move: 'Move around the image',
	},
	tour: {
		launcher: 'Take a tour',
		skip: 'Skip',
		back: 'Back',
		next: 'Next',
		done: 'Got it',
		payloadNew: {
			rail: {
				title: 'Quick navigation',
				body: 'Jump straight to any section of the page from this side menu. It stays visible while you scroll.',
			},
			identity: {
				title: 'Store information',
				body: 'General store info: storefront photo (when available), name, code, Id, location and creation date in the system. You can also see whether the payload was sent online or offline.',
			},
			payload: {
				title: 'Payload information',
				body: 'Workspace, module, submodule, configuration, user, cycle and geographic area. All the operational metadata for this record.',
			},
			status: {
				title: 'Payload status',
				body: 'Current status of the payload with the date of its last update. You have access to the full history to see every state it went through.',
			},
			location: {
				title: 'Payload location',
				body: 'Map showing the store position (red) and where the user started the census (blue). The distance between the two appears in the right panel.',
			},
			score: {
				title: 'Payload score',
				bodyBefore: 'Overall score and breakdown by indicator group. Each KPI shows its score and a',
				bodyAfter: 'with extra context when it applies.',
			},
			insights: {
				title: 'Payload insights',
				body: 'Summary of evaluated rules — how many pass, fail or do not apply. You can open the detailed view with every rule individually.',
			},
			content: {
				title: 'Payload content',
				body: 'Form data the user captured in the field: every question with its answer and the associated photos when they apply.',
			},
			pdf: {
				title: 'Download technical sheet',
				body: 'Generate a PDF with the full payload summary, downloadable in one click.',
			},
			share: {
				title: 'Share the URL',
				body: 'Copy this payload\'s link to the clipboard to send it to someone else in one click.',
			},
		},
		surveyResponse: {
			rail: {
				title: 'Quick navigation',
				body: 'Jump straight to any section of the page from this side menu. It stays visible while you scroll.',
			},
			identity: {
				title: 'Store information',
				body: 'General store info: storefront photo (when available), name, code, Id, location and creation date in the system.',
			},
			payload: {
				title: 'Survey information',
				body: 'Schema, user, workspace and the date the response was submitted. All the operational metadata for this record.',
			},
			score: {
				title: 'Survey score',
				bodyBefore: 'Overall score and breakdown by indicator group. Each KPI shows its score and a',
				bodyAfter: 'with extra context when it applies.',
			},
			content: {
				title: 'Survey content',
				body: 'Form data the user captured in the field: every question with its answer and the associated photos when they apply.',
			},
		},
		displayNew: {
			rail: {
				title: 'Quick navigation',
				body: 'Jump straight to any section of the page from this side menu. It stays visible while you scroll.',
			},
			info: {
				title: 'Image information',
				body: 'Filename, type and tags associated with the image. The image Id is right next to the section title and can be copied with a click.',
			},
			toolbar: {
				title: 'Recognition controls',
				body: 'Switch between result types when the image has more than one, and pick which detection layer you want to display.',
			},
			history: {
				title: 'Result history',
				body: 'Browse previous results for this image. Only available for Percepthor users; useful for debugging or comparing runs.',
			},
			picbtns: {
				title: 'Image controls',
				body: 'Fit the image to the frame, open it in a new window, download it, or open the keyboard shortcuts modal.',
			},
			taglist: {
				title: 'Detected items',
				body: 'List of products detected with their color, quantity and metadata. Toggle visibility per row or for all at once, and adjust the box opacity.',
			},
			caption: {
				title: 'Model and version',
				body: 'Model and version that generated the current result. Useful to compare runs or identify which configuration was used.',
			},
			summary: {
				title: 'Recognition summary',
				body: 'Custom fields returned by the result, like brand counts or shelf metrics, displayed as a quick-read summary.',
			},
			chart: {
				title: 'Products distribution',
				body: 'Horizontal bar chart sorted by quantity. Switch the grouping (products, brand, type, etc.) to see different aggregates.',
			},
		},
	},
  ticketModal: {
    instuction: 'If you have not selected a result, select it before creating a ticket.',
    project: 'Project',
    name: 'Name',
    description: 'Description',
    cancel: 'Cancel',
    create: 'Create',
    creating: 'Creating...'
  },
  tagList: {
    colorSwal: {
      title: 'Transparency setting',
			text: 'Color transparency for articles',
    },
    tableHeaders: {
      color: 'Color',
      quantity: 'Quantity',
      products: 'Products',
      price: 'Price',
      score: 'Score'
    },
    errors: {
      noProducts: 'No products'
    }
  },
	reconTable: {
		productCount: 'No. of Products',
		frontCount: 'No. of Fronts'
	},
  tagChart: {
    errors: {
      noProducts: 'No products'
    }
  },

	// TICKETS COMPONENTS
	tickets: {
		filters: {
			projectLegend: 'Select a project.',
		},
		help: {
			title: 'Which project should I select?',
			msg: 'Projects that start with "Test -" contain tickets intended for internal testing. The other projects contain tickets that are aimed at their review and correction in a production environment.'
		}
	},
	ticketsTable: {
		errors: {
			noTickets: 'No tickets'
		}
	},

	// FRAUD
	fraud: {
		allFraudsTitle: 'Search Falsification of Information',
		alert: {
			msg: 'It was detected that this location may have a possible duplication in some of its pictures.',
			link: 'Go to report',
			btn: 'View falsification report'
		},
		title: 'False Information Report',
		print: 'Print',
		false: 'Falsification',
		data: {
			image: 'Image',
			imageDate: 'Image Date',
			coordinates: 'Coordinates'
		},
		image: 'Image Similarity',
		products: 'Product Similarity',
		validationBtn: 'Start Validation Process',
		reviewMsg: 'The information has been verified by the supervisor.',
		confirm: {
			title: 'Are you sure you want to validate this location?',
			msg: 'This action will add the location to your route and cannot be undone.'
		},
		alerts: {
			success: 'The process has started, review your route in the app.',
			error: 'Error, please try again'
		},
		errorPageTitle: 'This payload does not have falsification of information.'
	},

  // UTILS COMPONENTS
  selectButton: {
    placeholder: 'Select...',
    noOptionsMessage: 'No options',
		loadingMessage: 'Loading options...'
  },
  pagination: {
		rows: 'Rows per page:',
    of: 'of'
  },
	confirmDialog: {
		confirmBtn: 'Confirm',
	},

  // STATUS DESCRIPTIONS
  statusDesc: {
    payload: {
      none: 'None',
      created: 'Created',
      waiting: 'Waiting',
      processing: 'Processing',
      good: 'Good',
      incomplete: 'Incomplete',
      bad: 'Bad',
      flagged: 'Flagged',
      in_review: 'In review',
      passed: 'Passed',
      removed: 'Removed',
      error: 'Error'
    },
		imgStatus: {
			none: 'None',
			available: 'Available',
			lost: 'Lost',
			review: 'Review',
			blocked: 'Blocked',
			missing: 'Missing',
			removed: 'Removed',
			archived: 'Archived',
		},
    imgRecon: {
      none: 'None',
      waiting: 'Waiting',
      success: 'Success',
      error: 'Error',
      reviewed: 'Reviewed',
      unavailable: 'Unavailable'
    },
		imgType: {
			none: 'None',
			common: 'Common',
			upload: 'Upload',
			output: 'Output',
			backup: 'Backup'
		},
		imgGroup: {
			none: 'None',
			organization: 'Organization',
			module: 'Module',
			location: 'Location',
			payload: 'Payload',
			result: 'Result',
			issue: 'Issue',
			post: 'Post',
			notification: 'Notification'
		},
    location: {
      none: 'None',
      available: 'Available',
      disabled: 'Disabled',
      removed: 'Removed'
    },
    record: {
      none: 'None',
      payload: 'Payload',
      issue: 'Issue',
      retry: 'Retry',
      other: 'Other'
    },
    issue: {
      none: 'None',
      closed: 'Closed',
      closed_down: 'Closed down',
      access: 'Access',
      process: 'Process',
      products: 'Products',
      custom: 'Custom'
    },
    cycle: {
      none: 'None',
      created: 'Created',
      starting: 'Starting',
      available: 'Available',
      waiting: 'Waiting',
      completed: 'Completed',
      removed: 'Removed'
    },
		ticket: {
			none: 'None',
			open: 'Open',
			review: 'In review',
			approved: 'Approved',
			partial: 'Partially approved',
			rejected: 'Rejected',
			// Legacy: the backend no longer writes 6, but tickets resolved
			// before the change stay in that state.
			closed: 'Closed',
			outdated: 'Outdated',
			error: 'Error'
		}
  },

  // SURVEYS COMPONENTS
  surveys: {
    list: {
      title: 'Surveys',
      filters: {
        schema: 'Schemas',
        schemaLegend: 'Select a schema.',
        from: 'From',
        to: 'To',
        dateLegend: 'Filter by date range (optional).',
        code: 'Store code',
        codeLegend: 'Filter by store code (optional).',
        codePlaceholder: 'e.g. 117812672',
        areasLegend: 'Filter by region, zone, depot, group or route (optional).',
        searchType: {
          label: 'Search by',
          byCode: 'Store code',
          byRoute: 'Route',
          routeUnavailable: 'The selected schema does not support route search.'
        },
        clear: 'Clear filters'
      },
      table: {
        source: 'Source',
        reference: 'Reference',
        name: 'Name',
        code: 'Code',
        route: 'Route',
        depot: 'Depot',
        photos: 'Photos',
        action: 'View',
        copyOid: 'Copy ID',
        noResults: 'No results'
      },
      chart: {
        title: 'Captures per day',
        total: 'total in the period',
        empty: 'No captures in the period.',
        loading: 'Loading…'
      },
      quickLookup: {
        title: 'Go directly by ID',
        help: 'If you know the response ID, open its details without applying filters.',
        idLabel: 'Response ID',
        placeholder: 'Paste the response ID here',
        goBtn: 'Go to details',
        loading: 'Searching...',
        invalidId: 'Could not find a survey response with that reference.'
      }
    },
    response: {
      title: 'Survey Details',
      info: {
        title: 'Survey Info',
        schema: 'Schema',
        user: 'User',
        workspace: 'Workspace',
        creationDate: 'Creation date'
      },
      content: {
        title: 'Survey Content',
        noContent: 'No content available'
      },
      share: {
        prompt: 'Need to share this survey?',
        copyUrl: 'Copy URL',
        copied: 'Copied!'
      },
      inspection: {
        launcher: 'Inspect',
        back: 'Back to survey',
        title: 'Inspection',
        eyebrow: 'GEPP inspection',
        loading: 'Loading inspection…',
        refetching: 'Refreshing…',
        noDomain: 'This survey has no source; cannot inspect.',
        checks: 'Checks',
        timeline: 'Timeline',
        geppLogs: 'GEPP status lifecycle',
        monitor: 'Monitor & steps',
        requests: 'HTTP requests',
        files: 'Files',
        counts: 'Related counts',
        raw: 'Raw JSON',
        copyJson: 'Copy JSON',
        copy: 'Copy',
        copied: 'Copied',
        jsonTitle: 'json'
      }
    }
  }
};
